import { PostNextServiceWarnings } from "@/server-types";
import { useCustomQuery } from "../custom-query";
import { post } from "../request-helpers";

type NextServiceWarningsBody = PostNextServiceWarnings["body"];

function hasSameContext(
  a: NextServiceWarningsBody,
  b: NextServiceWarningsBody,
): boolean {
  return (
    a.locationId === b.locationId &&
    a.startTime === b.startTime &&
    JSON.stringify(a.users) === JSON.stringify(b.users) &&
    JSON.stringify(a.resources) === JSON.stringify(b.resources)
  );
}

export const useGetNextServiceWarnings = (body: NextServiceWarningsBody) => {
  return useCustomQuery({
    queryKey: ["getNextServiceWarnings", body],
    queryFn: () =>
      post<PostNextServiceWarnings>("/calendar/service/next-warnings", body),
    // Previous warnings only stay valid while the user, resource, location and time are unchanged
    placeholderData: (previousData, previousQuery) => {
      const previousBody = previousQuery?.queryKey[1] as
        | NextServiceWarningsBody
        | undefined;

      return previousBody && hasSameContext(previousBody, body)
        ? previousData
        : undefined;
    },
  });
};
